import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/auth/auth-guard.service';









import { SettingsPageViewModeEnum } from './models/ViewModeEnum';





const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./layouts/full/full-layout.component').then(m => m.FullLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('../app/pages/home/home.module').then(m => m.routes)
      },
      {
        path: 'clienti',
        loadChildren: () => import('./pages/clienti/clienti.module').then(m => m.routes)
      },
      {
        path: 'av0',
        loadChildren: () => import('./pages/av0/av0.module').then(m => m.routes)
      },
      {
        path: 'av1',
        loadChildren: () => import('./pages/av1/av1.module').then(m => m.routes)
      },
      {
        path: 'av2',
        loadChildren: () => import('./pages/av2/av2.module').then(m => m.routes)
      },
      {
        path: 'av4',
        loadChildren: () => import('./pages/av4/av4.module').then(m => m.routes)
      },
      {
        path: 'av5',
        loadChildren: () => import('./pages/av5/av5.module').then(m => m.routes)
      },
      {
        path: 'av6',
        loadChildren: () => import('./pages/av6/av6.module').then(m => m.routes)
      },
      {
        path: 'av7',
        loadChildren: () => import('./pages/av7/av7.module').then(m => m.routes)
      },
      {
        path: 'scadenziario',
        loadChildren: () => import('./pages/scadenziario/scadenziario.module').then(m => m.routes)
      },
      {
        path: 'verificatitolareeffettivo',
        loadChildren: () => import('./pages/verifica-titolare-effettivo/verifica-titolare-effettivo.module').then(m => m.routes)
      },
      {
        path: 'rivenditori',
        loadChildren: () => import('../app/pages/rivenditori/rivenditori.module').then(m => m.routes)
      },
      {
        path: 'utenti',
        loadChildren: () => import('../app/pages/utenti/utenti.module').then(m => m.routes)
      },
      {
        path: 'news',
        loadChildren: () => import('../app/pages/news/news.module').then(m => m.routes)
      },
      {
        path: 'licenze',
        loadChildren: () => import('./pages/licenze/licenze.module').then(m => m.routes)
      },
      {
        path: 'updates',
        loadChildren: () => import('./pages/update/update.module').then(m => m.routes)
      },
      {
        path: 'tipilicenze',
        loadChildren: () => import('./pages/tipi-licenze/tipi-licenze.module').then(m => m.routes)
      },
      {
        path: 'visuretester',
        loadComponent: () => import('./visure-tester/visure-tester.component').then(m => m.VisureTesterComponent)
      },
      {
        path: 'datistudio',
        loadComponent: () => import('./pages/settings-page/settings-page.component').then(m => m.SettingsPageComponent),
        data: {
          viewmode: SettingsPageViewModeEnum.DatiStudio,
        }
      },
      {
        path: 'sicurezza',
        loadComponent: () => import('./pages/settings-page/settings-page.component').then(m => m.SettingsPageComponent),
        data: {
          viewmode: SettingsPageViewModeEnum.Sicurezza,
        }
      },
      {
        path: 'license',
        loadComponent: () => import('./pages/license-page/license-page.component').then(m => m.LicensePageComponent)
      },
      {
        path: 'customize',
        loadComponent: () => import('./pages/customize-page/customize-page.component').then(m => m.CustomizePageComponent)
      },
      {
        path: 'notifications',
        loadComponent: () => import('./pages/notifications-page/notifications-page.component').then(m => m.NotificationsPageComponent)
      }
    ], canActivate: [AuthGuard], canActivateChild: [AuthGuard]
  },
  { path: 'login', loadComponent: () => import('./pages/login-page/login-page.component').then(m => m.LoginPageComponent) },
  { path: 'privacypolicy', loadComponent: () => import('./pages/privacy-policy-page/privacy-policy-page.component').then(m => m.PrivacyPolicyPageComponent) },
  { path: 'register', loadComponent: () => import('./pages/register-page/register-page.component').then(m => m.RegisterPageComponent) },
  { path: 'forgotpassword', loadComponent: () => import('./pages/forgot-password-page/forgot-password-page.component').then(m => m.ForgotPasswordPageComponent) },
  { path: 'resetpassword', loadComponent: () => import('./pages/reset-password-page/reset-password-page.component').then(m => m.ResetPasswordPageComponent) },
  { path: 'error', loadComponent: () => import('./pages/error-page/error-page.component').then(m => m.ErrorPageComponent) },
  { path: '**', loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent) },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
